import React from "react"
import { StoryblokComponent, storyblokEditable } from "gatsby-source-storyblok"
import moment from 'moment'
import { Lang, LangEnum } from "../utils/lang"
import SideTourItem from "./sideTourItem"
import * as styles from "./blogArticle.module.css"
import SideBarCta from "./sideBarCta"

const BlogArticle = ({ blok, first_published_at, published_at }) => {
  
  const lang = Lang()

  const publishedAt = moment.utc(published_at)
  const firstPublishedAt = moment.utc(first_published_at)

  const postDate = firstPublishedAt.isValid() ? firstPublishedAt : moment()  // display first published date if available
  const postOrUpdated = firstPublishedAt.isValid() ? "Posted" : "Updated"

  // console.log(blok)
  let headArr = []
  blok.content?.forEach(c => {
    if (c.component === "bodyText") {
      c.paragraphs?.content?.forEach(p => {
        if (p.type === "heading" && p.attrs.level < 3 && p.content && p.content[0].text) {
          headArr.push({id: c._uid, name: p.content[0].text})
        }
      })
    }
  });
  // console.log(headArr)

  return (
    <section className="relative overflow-hidden" {...storyblokEditable(blok)}>
      <div className="relative h-[500px] overflow-hidden text-white">
        { blok.image && blok.image.filename &&
          <img
            className="absolute w-full h-[500px] object-cover object-center"
            alt={blok.image.alt}
            loading="lazy" src={blok.image.filename}
          />
        }
        <div className="absolute inset-0 bg-gradient-to-t from-gray-950 to-transparent h-[550px]"></div>
        <div className="absolute inset-0 title-font font-medium flex flex-col items-center justify-center h-[500px] p-4 text-center">
          { lang == LangEnum.EN &&
          <nav className="text-center">
            <a href={`${lang}/`} className="hover:text-gray-300 border-b-2">Home</a>
            <img src="/icons/breadcrumb-arrow-right.svg" alt="breadcrumb" className="inline-block w-4 h-4 mx-4" />
            <a href={`${lang}/blogs`} className="hover:text-gray-300 border-b-2">Blogs</a>
            <div className="w-full">
              <img src="/icons/breadcrumb-arrow-down.svg" alt="breadcrumb" className="ml-24 inline-block w-4 h-4 my-4" />
            </div>
          </nav>
          }
          <h2 className="title-font text-2xl mb-6 font-medium font-serif">
            {blok.subHeading}
          </h2>
          <h1 className="text-4xl md:text-5xl pb-10 font-serif">{blok.title}</h1>
        </div>
      </div>

      <div className="flex justify-center flex-col gap-8 md:flex-row">
      
        <div className="article-date-container order-1 md:w-[212px] px-4 mt-10">
          <div className="flex flex-col font-medium items-center justify-center">
            <span className="text-base">{postDate.format('YYYY')}</span>
            <span className="text-xs">-----</span>
            <span className="text-xl font-bold uppercase">{postDate.format('MMM')}</span>
            <span className="text-xs">-----</span>
            <span className="text-2xl">{postDate.format('D')}</span>
            <span className="text-xs font-normal mt-3">{postOrUpdated}</span>
          </div>

          <div className="flex flex-col items-center justify-center my-5 border-black border-t-4 border-b-4 py-8 w-[120px] mx-auto">
          { 
            blok.category && blok.category.map((cat, index) => (
              <div className="flex items-center text-red-700 text-sm" key={index}>
                <div className="mr-2">●</div>
                <a href={"/" + cat.full_slug} className="mr-2">{cat.name}</a>
              </div>
            ))
          }
          </div>

          <div className="flex flex-col items-center justify-center">
          { 
            blok.label && 
            <img className="w-4 h-4 align-middle mr-2 mb-2" src="/icons/tag.svg" alt="Tag icon"/>
          }
          {
            blok.label?.value?.map((tag, index) => (
              <span className="text-blue-700 text-xs border-b-4 border-blue-700 mr-2 mb-2" key={index}>
                <a href={`${lang}/blogs?label=${tag}`}>{tag}</a>
              </span>
            ))
          }
          </div>
        </div>

        <div className="content-conteinr order-3 md:order-2 flex px-2 py-10 items-center justify-center flex-col">
          <div className={`${styles.blog_content} text-center max-w-[360px] sm:max-w-[450px] md:max-w-[640px] lg:max-w-[740px]`}>
            <div className={`${styles.excerpt} mb-16 leading-relaxed text-left text-gray-600`} dangerouslySetInnerHTML={{__html: blok.excerpt}} />

            {/* table of content */}
            {blok.contexts && headArr.length > 0 && 
              <div className="mb-10 py-6 px-10 bg-gray-100 text-left rounded-lg">
                <div className="text-2xl font-bold mb-3">On this page:</div>
                <ul className="list-disc list-inside">
                  {headArr.map((h, index) => (
                    <li key={index} className="text-blue-700 mb-2"><a href={`#${h.id}`}>{h.name}</a></li>
                  ))}
                </ul>
              </div>
            }


            {/* blog contents */}
            {blok.content && blok.content.map(b => (<StoryblokComponent blok={b} key={b._uid} />))}
            <div className="mb-8 leading-relaxed text-left" dangerouslySetInnerHTML={{__html: blok.oldContent}} />
          </div>
        </div>

        <div className="side-item-container md:w-[212px] order-2 md:order-3 flex flex-col mt-10 items-center">
          {blok.sideTourItem?.map((tour, index) => 
            <div className="w-[180px] mx-4 my-2 border-b border-dashed hover:shadow-md transition" key={index}>
              <SideTourItem blok={tour} />
            </div>
          )}

          {blok.sideBarCtaList?.map((cta, index) =>
            <SideBarCta blok={cta} key={index} />
          )}

        </div>

      </div>

      {blok.bottomBlocks?.map((nestedBlok) => (
        <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
      ))}
      
    </section>
  )
}

export default BlogArticle
